export type TableSearchValues = Record<string, string | null | undefined>

export const TABLE_QUERY_RESERVED_KEYS = new Set([
  'page',
  'size',
  'sortBy',
  'key',
])

const cache = new Map<string, TableSearchValues>()

export const getTableSearchCache = (scope: string): TableSearchValues => ({
  ...(cache.get(scope) ?? {}),
})

export const setTableSearchCacheValue = (
  scope: string,
  accessor: string,
  value: string | null,
): TableSearchValues => {
  const next = { ...(cache.get(scope) ?? {}) }
  if (value == null || value === '') {
    delete next[accessor]
  } else {
    next[accessor] = value
  }
  cache.set(scope, next)
  return next
}
